import {AskStatsCard} from '~/features/Ask/AskStats/AskStatsCard';

import {HomepageCard} from '~/components/cards/HomepageCard';

export const DashboardScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <div className="p-6 flex flex-wrap gap-5">
        <AskStatsCard />
        <HomepageCard
          title="User Lookup"
          image="https://www.datocms-assets.com/79195/1707237389-plan-your-perfect-date.png"
          description="Search for a user by ID to find information about them"
          url="/user-lookup"
        />
        <HomepageCard
          title="Reward Code Lookup"
          image="https://www.datocms-assets.com/79195/1707409127-2.png"
          description="Find out more information about a user from their Luna Reward code!"
          url="/reward-lookup"
        />
        <HomepageCard
          title="Poll Information"
          image="https://www.datocms-assets.com/79195/1696758162-1.png"
          description="Everything you need to know about a poll, including the results to date 🗳️"
          url="/polls"
        />
        <HomepageCard
          title="Premium Subscription Stats"
          image="https://www.datocms-assets.com/108981/1713536228-single-images.png"
          description="Find out how many premium subscriptions are active right now, including lifetime users and teens with access via ParentPay"
          url="/premium-stats"
        />
      </div>
    </div>
  );
};
